import quoteGQLString from '../../util/quoteGQLString';

export default (patent) => `
    id: ${quoteGQLString(patent?.id)}
`;
